import { useEffect } from "react";
import { useSceneNodes } from "./SecondaryScene";
import CameraManager from "../manager/CameraManager";
import useFlowStore from "../store/flowStore";
import { audios } from "../../assets/assets";

export default function NuageScene() {
  const { nuage } = useSceneNodes();

  useEffect(() => {
  }, [nuage]);

  useEffect(() => {
    if (!nuage) return;
  
    const { currentStep, flowSteps, nextStep } = useFlowStore.getState();
    const step = flowSteps[currentStep];
    
    if (step?.label === "Nuages") {
        const swooshAudio = new Audio(audios.swoosh_cloud_to_room);
        swooshAudio.play().catch(console.warn);
        CameraManager.playAnimation(() => {
          CameraManager.reset();
          CameraManager.switchCamera("camera_2");
          
          setTimeout(() => {
            nextStep(() => {
              console.log("Scène Nuages terminée ! Room Scene");
              CameraManager.enableMouseLook(1);
            });
          }, 100);
        }, 4000);
    }
  }, [nuage, useFlowStore((s) => s.currentStep)]);


  const handleClick = (e) => {
    e.stopPropagation();
    const clicked = e.object;
    if (clicked.userData.isClickable && clicked.userData.onClick) {
      clicked.userData.onClick();
    }
  };

  if (!nuage) return null;

  return <primitive object={nuage} onPointerDown={handleClick} />;
}
